import { ApiError } from '@anm/api';
import { Brand, BrandFile, CreateBrandFileRequest, DeleteLogoParams } from '@anm/api/modules/brands';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';

import { UploadBrandLogoPrams } from './types';

export const fetchBrands = createAction('wave.video/branding/FETCH_BRANDS')();

export const fetchBrandsAsync = createAsyncAction(
  'wave.video/branding/FETCH_BRANDS_REQUEST',
  'wave.video/branding/FETCH_BRANDS_SUCCESS',
  'wave.video/branding/FETCH_BRANDS_FAILURE'
)<void, Brand[], ApiError>();

export const uploadBrandLogo = createAction('wave.video/branding/UPLOAD_BRAND_LOGO')<UploadBrandLogoPrams>();

export const uploadBrandLogoAsync = createAsyncAction(
  'wave.video/branding/UPLOAD_BRAND_LOGO_REQUEST',
  'wave.video/branding/UPLOAD_BRAND_LOGO_SUCCESS',
  'wave.video/branding/UPLOAD_BRAND_LOGO_FAILURE'
)<UploadBrandLogoPrams, Brand, ApiError>();

export const updateCurrentBrandId = createAction('wave.video/branding/UPDATE_CURRENT_BRAND_ID')<number>();

export const clearUploadedBrand = createAction('wave.video/branding/CLEAR_UPLOADED_BRAND')();

export const deleteBrandLogo = createAction('wave.video/branding/DELETE_BRAND_LOGO')<DeleteLogoParams>();

export const deleteBrandLogoAsync = createAsyncAction(
  'wave.video/branding/DELETE_BRAND_LOGO_REQUEST',
  'wave.video/branding/DELETE_BRAND_LOGO_SUCCESS',
  'wave.video/branding/DELETE_BRAND_LOGO_FAILURE'
)<DeleteLogoParams, Brand, ApiError>();

export const createBrandFile = createAction('wave.video/branding/CREATE_BRAND_FILE')<CreateBrandFileRequest>();

export const createBrandFileAsync = createAsyncAction(
  'wave.video/branding/CREATE_BRAND_FILE_REQUEST',
  'wave.video/branding/CREATE_BRAND_FILE_SUCCESS',
  'wave.video/branding/CREATE_BRAND_FILE_FAILURE'
)<CreateBrandFileRequest, BrandFile, ApiError>();
